const LOCAL_API_URL = 'http://localhost:3001/api';
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : LOCAL_API_URL;

const OPEN_STATUS = { away: false, backOn: '', message: '' };

// Fails open: if the backend can't be reached, the site behaves as open
export const fetchSiteStatus = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/status`);
    if (!response.ok) return OPEN_STATUS;
    return { ...OPEN_STATUS, ...(await response.json()) };
  } catch {
    return OPEN_STATUS;
  }
};

export const checkAdminPassword = async (password) => {
  const response = await fetch(`${API_BASE_URL}/admin/login`, {
    method: 'POST',
    headers: { 'x-admin-password': password },
  });
  return response.ok;
};

export const saveSiteStatus = async (password, status) => {
  const response = await fetch(`${API_BASE_URL}/admin/status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-admin-password': password },
    body: JSON.stringify(status),
  });
  if (!response.ok) throw new Error('Could not save');
  return response.json();
};

// "2026-10-05" -> "5th October 2026"
export const formatBackDate = (iso) => {
  if (!iso) return '';
  const d = new Date(`${iso}T00:00:00`);
  if (isNaN(d)) return '';
  const day = d.getDate();
  const suffix = day % 10 === 1 && day !== 11 ? 'st'
    : day % 10 === 2 && day !== 12 ? 'nd'
    : day % 10 === 3 && day !== 13 ? 'rd' : 'th';
  return `${day}${suffix} ${d.toLocaleString('en-GB', { month: 'long' })} ${d.getFullYear()}`;
};
